/* codex-disable-purchase-actions:start */
(function () {
  'use strict';

  var disabledMessage = 'Checkout is temporarily disabled.';
  var disabledClass = 'codex-purchase-disabled';

  function isPurchaseElement(element) {
    if (!element || element.nodeType !== 1) return false;
    var selector = [
      'form[action*="/cart/add"] button',
      'form[action*="/cart/add"] input[type="submit"]',
      'button[name="add"]',
      '[name="add"]',
      '.shopify-payment-button button',
      '.shopify-payment-button__button',
      'shopify-accelerated-checkout',
      '[data-testid*="Checkout"]',
      '[data-testid*="checkout"]',
      '[id*="gokwik" i]',
      '[class*="gokwik" i]',
      '[data-gokwik]'
    ].join(',');

    try {
      return element.matches(selector) || !!element.closest(selector);
    } catch (error) {
      return false;
    }
  }

  function disableNativeControl(element) {
    if (!element || element.nodeType !== 1) return;
    var tag = element.tagName;
    if (tag === 'BUTTON' || tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA') {
      element.disabled = true;
    }
    element.setAttribute('aria-disabled', 'true');
    element.setAttribute('data-codex-purchase-disabled', 'true');
    element.setAttribute('title', disabledMessage);
    element.classList.add(disabledClass);
  }

  function applyDisabledState(root) {
    root = root || document;
    var controls = root.querySelectorAll([
      'form[action*="/cart/add"] button',
      'form[action*="/cart/add"] input[type="submit"]',
      'button[name="add"]',
      '[name="add"]',
      '.shopify-payment-button button',
      '.shopify-payment-button__button',
      'shopify-accelerated-checkout',
      '[id*="gokwik" i]',
      '[class*="gokwik" i]',
      '[data-gokwik]'
    ].join(','));

    controls.forEach(function (control) {
      disableNativeControl(control);
      if (!/^(BUTTON|INPUT|SELECT|TEXTAREA)$/.test(control.tagName)) {
        control.setAttribute('tabindex', '-1');
      }
    });

    var forms = root.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(function (form) {
      form.setAttribute('data-codex-purchase-disabled', 'true');
      form.setAttribute('aria-disabled', 'true');
    });
  }

  function ensureStyle() {
    if (document.getElementById('codex-disable-purchase-actions-style')) return;
    var style = document.createElement('style');
    style.id = 'codex-disable-purchase-actions-style';
    style.textContent = [
      '.codex-purchase-disabled,',
      '[data-codex-purchase-disabled="true"] .shopify-payment-button__button {',
      '  opacity: .55 !important;',
      '  cursor: not-allowed !important;',
      '  filter: grayscale(1) !important;',
      '}',
      '.codex-purchase-disabled *,',
      '[data-codex-purchase-disabled="true"] * {',
      '  cursor: not-allowed !important;',
      '}',
      'form[data-codex-purchase-disabled="true"] button,',
      'form[data-codex-purchase-disabled="true"] input[type="submit"] {',
      '  opacity: .55 !important;',
      '  cursor: not-allowed !important;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function blockEvent(event) {
    var target = event.target;
    if (event.type === 'submit') {
      var form = target && target.closest ? target.closest('form') : target;
      if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return false;
      }
    }
    if (isPurchaseElement(target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return false;
    }
  }

  function urlLooksBlocked(input) {
    var value = '';
    if (typeof input === 'string') value = input;
    else if (input && input.url) value = input.url;
    return /\/cart\/add(?:\.js|\.json)?(?:\?|$)/i.test(value);
  }

  function blockNetworkAddToCart() {
    if (window.fetch && !window.fetch.__codexPurchaseDisabled) {
      var originalFetch = window.fetch;
      var wrappedFetch = function (input, init) {
        if (urlLooksBlocked(input)) {
          return Promise.reject(new Error(disabledMessage));
        }
        return originalFetch.apply(this, arguments);
      };
      wrappedFetch.__codexPurchaseDisabled = true;
      window.fetch = wrappedFetch;
    }

    if (window.XMLHttpRequest && !window.XMLHttpRequest.prototype.__codexPurchaseDisabled) {
      var originalOpen = window.XMLHttpRequest.prototype.open;
      window.XMLHttpRequest.prototype.open = function (method, url) {
        this.__codexBlockedUrl = urlLooksBlocked(url);
        return originalOpen.apply(this, arguments);
      };
      var originalSend = window.XMLHttpRequest.prototype.send;
      window.XMLHttpRequest.prototype.send = function () {
        if (this.__codexBlockedUrl) {
          try { this.abort(); } catch (error) {}
          throw new Error(disabledMessage);
        }
        return originalSend.apply(this, arguments);
      };
      window.XMLHttpRequest.prototype.__codexPurchaseDisabled = true;
    }
  }

  function boot() {
    ensureStyle();
    applyDisabledState(document);
    blockNetworkAddToCart();
    document.addEventListener('click', blockEvent, true);
    document.addEventListener('submit', blockEvent, true);
    var observer = new MutationObserver(function () { applyDisabledState(document); });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
/* codex-disable-purchase-actions:end */